module.exports = __webpack_public_path__ + "src/img/del.b9641be0.svg";